import React from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { HEADER, APPOINTMENTS, APPOINTMENT_STATUS, REFERRAL } from '_constants';
import { headerActions, appointmentActions, customModalActions } from 'actions';
import { APPOINTMENT_DISPOSITIONS } from '../../../constants';
import BasicModal from '../../common/modals/BasicModal';
import infoIcon from 'assets/images/info-icon-blue.png';

const moment = require('moment');

class RescheduleAppointment extends React.Component {
    static propTypes = {
      // ownProps

      // mapStateToProps
      appointment: PropTypes.object.isRequired,
      fetchDispositions: PropTypes.func.isRequired,
      setHeader: PropTypes.func.isRequired,
      rescheduleAppointment: PropTypes.func.isRequired,
      updateCustomModal: PropTypes.func.isRequired,
      hideCustomModal: PropTypes.func.isRequired
    }

    state = {
      startDate: moment(this.props.appointment.startDate).format('YYYY-MM-DD[T]HH:mm'),
      endTime: moment(this.props.appointment.endDate).format('HH:mm'),
      rescheduleNotes: '',
      countMet: false,
      startDateErr: false,
      triedToSubmit: false,
      show: false,
      rescheduleDateErr: false
    }

    confirmCount = () => {
      if (this.state.rescheduleNotes.length >= 20) {
        this.setState({ countMet: true });
      } else { this.setState({ countMet: false }); }
    }

    checkForPastDate = (date) => moment(date) < moment();

    onChangeStartDate = (event) => {
      const startDate = event.target.value;
      const isPastDate = this.checkForPastDate(startDate);
      const endTime = moment(startDate).add(1, 'hour').format('HH:mm');
      const appointmentEventStatus = this.props.appointment.eventStatus.name;
      const rescheduleDateErr = this.checkForConfirmedAppointment(appointmentEventStatus, startDate);
      this.setState({ startDate: event.target.value, endTime: endTime, startDateErr: isPastDate, rescheduleDateErr: rescheduleDateErr });
    }

    onChangeEndTime = (event) => {
      const endTime = event.target.value;
      const startTime = moment(this.state.startDate).format('HH:mm');
      const endHour = endTime.split(':');
      const startHour = startTime.split(':');
      const endMoment = moment().hour(endHour[0]).minute(endHour[1]);
      const startMoment = moment().hour(startHour[0]).minute(startHour[1]);
      // TODO: Add checks for the date and time.
      if (moment().hour(endHour[0]).minute(endHour[1]) < moment().hour(startHour[0]).minute(startHour[1])) {
        // let key = Utilities.generateUniqueKey();
        // window.addModalContainer(<Alert id={key} key={key} message="End Time cannot be less than startTime"
        //    onClickOk={() => { this.setState({ endTime: startMoment.add(1, 'hour').format('HH:mm') }); window.popModal(); }}
        /// >);
      } else if (moment.duration(endMoment.diff(startMoment)).hours() > APPOINTMENTS.MAX_APPOINTMENT_DURATION) {
        this.props.updateCustomModal(true, null,
          'Appointment duration is too high',
          () => {
            this.setState({
              endTime: startMoment.add(1, 'hour').format('HH:mm')
            });
          }, null, () => {
            this.setState({
              endTime: startMoment.add(1, 'hour').format('HH:mm')
            });
            this.props.hideCustomModal();
          }, true, '', 'Ok', null, true, 'custom-modal', 'form-control reschedule-ok-btn');
        // let key = Utilities.generateUniqueKey();
        // window.addModalContainer(<Alert id={key} key={key} message="Appointment duration is too high"
        //    onClickOk={() => { this.setState({ endTime: startMoment.add(1, 'hour').format('HH:mm') }); window.popModal(); }}
        /// >);
      } else {
        this.setState({ endTime: endTime });
      }
    }

    handleChange = (event) => {
      this.setState({
        rescheduleNotes: event.target.value
      }, this.confirmCount);
    }

    hideModal = () => {
      this.setState({
        show: false
      });
    };

    checkForConfirmedAppointment = (appointmentEventStatus, startDate) => {
      const apptConfirmedDate = moment(this.props.appointment.startDate).format('YYYY-MM-DD[T]HH:mm');
      return _.isEqual(startDate, apptConfirmedDate) && _.isEqual(appointmentEventStatus, 'Confirmed');
    }

    showModal = () => {
      const { countMet, startDate, startDateErr } = this.state;
      const appointmentEventStatus = this.props.appointment.eventStatus.name;
      const isPastDate = this.checkForPastDate(startDate);
      const rescheduleDateErr = this.checkForConfirmedAppointment(appointmentEventStatus, startDate);
      this.setState({ triedToSubmit: true, startDateErr: isPastDate, rescheduleDateErr: rescheduleDateErr });
      if (countMet && !isPastDate && !startDateErr && !rescheduleDateErr) {
        this.setState({ show: true });
      }
    }

    rescheduleAppointment = (history) => {
      this.props.appointment.notes = this.state.rescheduleNotes;
      const isFromAppointmentDetails = _.get(this.props, 'location.state.from', null);
      if (_.isEqual(isFromAppointmentDetails, 'appointmentDetails')) {
        this.props.rescheduleAppointment(this.props.appointment, APPOINTMENT_DISPOSITIONS.RESCHEDULED_BY_AGENT, this.state.startDate, this.state.endTime, history, true);
      } else {
        this.props.rescheduleAppointment(this.props.appointment, APPOINTMENT_DISPOSITIONS.RESCHEDULED_BY_AGENT, this.state.startDate, this.state.endTime, history);
      }
    }

    componentDidMount = async () => {
      this.props.setHeader({
        type: HEADER.UPDATE_HEADER,
        showHeader: true,
        headerTitle: 'Reschedule Appointment',
        hasBackButton: true,
        backButtonIcon: 'back'
      });
      await this.props.fetchDispositions(APPOINTMENT_STATUS.RESCHEDULED.id);
    }

    render () {
      const { rescheduleNotes, countMet, startDateErr, triedToSubmit, rescheduleDateErr } = this.state;

      return (
        <React.Fragment>
          {
            this.state.show &&
            <BasicModal
              show={this.state.show}
              hideModal={this.hideModal}
              onOk={() => this.rescheduleAppointment(history)}
              showCloseButton
              dialogClassName={'confirm-appt-status-info-modal'}
              OkButtonText={'YES'}
              CancelButtonText={'NO'}
              title={
                <div className='modal-title'>
                  <img className='info-icon' src={infoIcon} />
                  <h6 className='center-align p-7 confirm-appt-title'>{APPOINTMENTS.CONFIRMING_APPOINTMENT}</h6>
                </div>
              }>
              <div>You are confirming the appointment for {moment(this.state.startDate).format('MM/DD/YYYY hh:mm A')}.</div>
              <div>An email and text will be sent to {this.props.appointment.contacts[0].firstName} {this.props.appointment.contacts[0].lastName}.</div>
              <div className='modal-message-first-line'>{APPOINTMENTS.CONFIRMATION_TEXT}</div>
            </BasicModal>
          }
          <div className='reschedule-time-row'>
            {
              startDateErr &&
              <div className={'sub-label-text pd-bt-5'}><sup>*</sup>Appointment cannot be rescheduled to past dates</div>
            }
            {
              rescheduleDateErr && (!startDateErr) &&
              <div className={'sub-label-text pd-bt-5'}><sup>*</sup>You already have a confirmed appointment at this time. Please change date/time.</div>
            }
            <span>Start</span>
            <span className='float-right'>
              <input
                type='datetime-local'
                className='reschedule-time full-width form-control'
                value={this.state.startDate}
                onChange={this.onChangeStartDate}
                min={moment().format('YYYY-MM-DD[T]HH:mm')}
              />
            </span>
          </div>
          <div className='reschedule-time-row'>
            <span>Ends</span>
            <span className='float-right'>
              <input
                type='time'
                className='reschedule-time full-width form-control'
                value={this.state.endTime}
                onChange={this.onChangeEndTime}
              />
            </span>
          </div>
          <div className='pd-8-10'>
            <span>Notes</span>
            {
              triedToSubmit && !countMet
                ? <span className='sub-label-text'> *Please enter at least 20 characters</span>
                : <span className='appointment-small-text'> (20 characters min.)</span>
            }
          </div>
          <div className='margin-lr-10'>
            <textarea
              className='appointment-notes'
              placeholder=' How did the appointment go?'
              rows='4'
              maxLength='160'
              onChange={this.handleChange}
            />
          </div>
          <div className='text-characters-count'>
            {`(${rescheduleNotes.length}/160)`}
          </div>
          <div className='appointment-disclaimer'>
            <div className='float-left alert-red-text'>*</div>
            <div>{REFERRAL.NOTE_DISCLAMIER}</div>
          </div>
          <div className='bottom-container'>
            <button
              className='appointment-primary-button'
              onClick={this.showModal}>Reschedule Appointment
            </button>
          </div>
        </React.Fragment>
      );
    }
}

const mapStateToProps = (state) => {
  return {
    appointments: state.appointments
  };
};

const mapDispatchToProps = dispatch => ({
  setHeader: bindActionCreators(headerActions.setHeader, dispatch),
  rescheduleAppointment: bindActionCreators(appointmentActions.rescheduleAppointment, dispatch),
  updateCustomModal: bindActionCreators(customModalActions.updateCustomModal, dispatch),
  hideCustomModal: bindActionCreators(customModalActions.hideCustomModal, dispatch)
});
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(RescheduleAppointment));
